import api from './request'
import type ExperienceData from '../types/experience'

export const getExperience = async (id: string): Promise<ExperienceData> => {
  const response = await api.get('/experiences/' + id)
  return response.data as ExperienceData
}
